import { ReactNode } from 'react';

interface Props {
  color?: 'black' | 'gray'
  children?: ReactNode;
}

export const PageSubHeading = ({ children, color = 'black' }: Props) => {
  let textColor = 'text-black';
  let borderColor = 'border-slate-300';
  if (color === 'gray') {
    textColor = 'text-gray-400';
    borderColor = 'border-slate-300';
  }

  return (
    <>
      {/* <h2 className="flex flex-row flex-nowrap items-center">
        <span className={`${textColor} block mr-2 pr-2 py-2.5 text-lg font-semibold whitespace-normal`}>
          {children}
        </span>
        <span className={`flex-grow block border-t ${borderColor}`}></span>
      </h2> */}


      {/* <h2 className="flex flex-col items-stretch">
        <span className={`${textColor} block mr-2 pr-2 py-2.5 text-lg font-semibold whitespace-normal`}>
          {children}
        </span>
        <span className={`flex-grow block border-t ${borderColor}`}></span>
      </h2> */}

      {/* <h2 className="flex flex-row items-center w-full">
        <span className={`${textColor} shrink mr-2 pr-2 py-2.5 text-lg font-semibold`}>
          {children}
        </span>
        <span className={`flex-grow border-t bg-gray-400 ${borderColor}`}></span>
      </h2> */}
      <h2 className="flex items-center">
        <span className={`border w-4 ${borderColor}`}></span>
        <span className={`px-3 max-w-[92%] font-semibold text-lg py-2.5 ${textColor}`}>{children}</span>
        <span className={`border flex-grow min-w-4 ${borderColor}`}></span>
      </h2>
    </>
  );
};
